<div class="row" style="position: absolute;bottom: 0;left: 0;right: 12px;height: 90px;    background-color: #383f53;z-index: 101; padding: 12px;">
    <div class="col-sm-3">
        <p style="text-align: left;
        font: normal normal bold 14px/18px Montserrat;
        letter-spacing: 0px;
        color: #FFFFFF;
        text-transform: uppercase;
        padding-top: 10px;
        opacity: 1;">ESCRITORIO DIGITAL</p>
        <p style="text-align: left;
        font: normal normal bold 14px/18px Montserrat;
        letter-spacing: 0px;
        color: #FFFFFF;
        text-transform: uppercase;
        opacity: 1;">del Jardín Infantil</p>
    </div>
    <div class="col-sm-6 d-flex mx-auto justify-content-center" style="    flex-direction: column;
    align-items: center;" >
        <p style="
        width: 230px;
        margin-bottom: 0px;
        color: #fff;
        font-weight: bold;
        font-family: 'Montserrat', sans-serif;
        font-size: 15px;
        padding-left: 12px;
        padding-right: 12px;
        border: none;
        border-radius: 0.25em;">Simulación de plataforma</p>
        <button type="button" class="btn btn-light btn-menu" (click)="volver()" style="width: 280px;
        height: 45px;
        background-color: #597CEE;
        color: #fff;
        font-weight: bold;
        font-family: 'Montserrat', sans-serif;
        font-size: 15px;
        padding-left: 12px;
        padding-right: 12px;
        border: none;
        border-radius: 0.25em;">                    
            <span style="color: #FFFFFF;">VOLVER A ADMINISTRADOR</span>
        </button>
    </div>
    <div  class="col-sm-3" style="text-align: right;">
                    
            <img src="../../../assets/icons/JUNJI__JUNJI-logo.svg" style="width: 100px;margin-right: 10px;">

    </div>
</div>

<div class="embed-responsive embed-responsive-16by9" style="position: absolute;top: 0;left: 0;right: 0;bottom: 90px;overflow: auto;">
<app-jardin [simulacion]="true"></app-jardin>
</div>